import React from 'react'

import { useAppSettings } from 'components/shared/SettingsProvider'

// NOTE: This wrapper does barely anything. It can be used for consistency with
// our HOC pattern, but it's also easy to just use the provider directly in a
// presentational component.
const withAppSettings = WrappedComponent => {
  return props => {
    const appSettings = useAppSettings()

    return <WrappedComponent appSettings={appSettings} {...props} />
  }
}

export default withAppSettings
